import moment from "moment";
import React from "react";

function ScheduleActivitiesList({
  title,
  sceduleActivityList,
  color,
  showDays = false,
}) {
  return (
    <>
      <div
        style={{
          borderBottom: "1px solid grey",
        }}
        className="row pb-2 pt-2  m-0 justify-content-between w-100"
      >
    <div className="px-2 col font-12" style={{ color }}>
          {title}
        </div>
        <div
          className="col d-flex justify-content-end font-11"
          style={{ color }}
        >
          {sceduleActivityList?.length}
        </div>
      </div>
      {/* <ul className="schedule-activity-list"> */}
      {sceduleActivityList.map((activity) => (
        <div key={activity.id} className="px-2 cursor-pointer py-2  border-bottom w-100">
          <div className="font-11 fw-bold">
            {activity?.activity_type_id?.[1]}
          </div>
          {showDays && (
            <div className="font-11">
              {Math.abs(moment().diff(moment(activity?.date_deadline), "days"))}{" "}
              days
            </div>
          )}
        </div>
      ))}
      {/* </ul> */}
      <div style={{ height: 10, backgroundColor: "#ededed" }}></div>
    </>
  );
}

export default ScheduleActivitiesList;
